import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { format, startOfMonth, endOfMonth, eachDayOfInterval, isSameDay, isToday, startOfWeek, endOfWeek } from 'date-fns';
import API from '../api';

export default function Calendar() {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [events, setEvents]             = useState([]);
  const [selectedClip, setSelectedClip] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const from = startOfMonth(currentMonth).toISOString();
    const to   = endOfMonth(currentMonth).toISOString();
    API.get('/api/calendar', { params: { from, to } }).then(r => setEvents(r.data)).catch(()=>{});
    API.get('/api/streamers').then(r => {
      if (r.data[0]) {
      }
    }).catch(()=>{});
  }, [currentMonth]);

  const monthStart = startOfMonth(currentMonth);
  const calStart   = startOfWeek(monthStart, { weekStartsOn: 1 });
  const calEnd     = endOfWeek(endOfMonth(currentMonth), { weekStartsOn: 1 });
  const days       = eachDayOfInterval({ start: calStart, end: calEnd });
  const dayNames   = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];

  const eventsOnDay = day => events.filter(e => isSameDay(new Date(e.scheduled_at), day));
  const truncate    = (str, n) => str && str.length > n ? str.slice(0, n) + '…' : str;

  return (
    <div>
      <div className="page-header">
        <div className="page-title">Content Calendar</div>
        <div className="page-subtitle">Scheduled posts and optimal posting times</div>
      </div>



      <div style={{display:'flex', alignItems:'center', gap:16, marginBottom:20}}>
        <button className="btn btn-ghost" onClick={() => setCurrentMonth(m => new Date(m.getFullYear(), m.getMonth()-1))}>←</button>
        <div style={{fontFamily:'var(--font-display)', fontWeight:700, fontSize:20, flex:1, textAlign:'center'}}>
          {format(currentMonth, 'MMMM yyyy')}
        </div>
        <button className="btn btn-ghost" onClick={() => setCurrentMonth(m => new Date(m.getFullYear(), m.getMonth()+1))}>→</button>
      </div>

      <div className="calendar-grid">
        {dayNames.map(d => <div key={d} className="calendar-day-header">{d}</div>)}
        {days.map(day => (
          <div key={day} className={`calendar-cell${isToday(day)?' today':''}`}>
            <div className="calendar-date" style={{color: isToday(day) ? 'var(--accent)' : undefined}}>
              {format(day, 'd')}
            </div>
            {eventsOnDay(day).map(e => (
              <div
                key={e.id}
                className="calendar-event"
                title={e.custom_title || e.ai_title}
                style={{cursor:'pointer'}}
                onClick={() => setSelectedClip(e)}
              >
                {format(new Date(e.scheduled_at), 'HH:mm')} {truncate(e.custom_title || e.ai_title, 14)}
              </div>
            ))}
          </div>
        ))}
      </div>

      {selectedClip && (
        <div
          style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000}}
          onClick={() => setSelectedClip(null)}
        >
          <div
            style={{background:'var(--surface)', border:'1px solid var(--border)', borderRadius:16, padding:28, maxWidth:480, width:'90%'}}
            onClick={e => e.stopPropagation()}
          >
            <div style={{fontFamily:'var(--font-display)', fontWeight:800, fontSize:18, marginBottom:4}}>
              {selectedClip.custom_title || selectedClip.ai_title}
            </div>
            <div style={{fontSize:12, color:'var(--text-muted)', marginBottom:16}}>
              Scheduled: {new Date(selectedClip.scheduled_at).toLocaleString('en-GB', {weekday:'short', day:'numeric', month:'short', hour:'2-digit', minute:'2-digit'})}
            </div>
            {selectedClip.s3_url && (
              <video src={selectedClip.s3_url} controls style={{width:'100%', borderRadius:8, marginBottom:16}} />
            )}
            <div style={{display:'flex', gap:10}}>
              <button
                className="btn btn-approve"
                style={{flex:1}}
                onClick={() => {
                  const tab = selectedClip.status === 'posted' ? 'posted' : 'scheduled';
                  navigate(`/clips?status=${tab}`);
                  setSelectedClip(null);
                }}
              >
                Go to clip →
              </button>
              <button className="btn btn-ghost" onClick={() => setSelectedClip(null)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
